/**
 * HTTP transport port for the Vello real clients (S097; M12).
 *
 * The client apps (Rider/Driver/Admin) are framework-neutral TypeScript. The *actual* network — `fetch` on
 * web, `expo/fetch` or the platform `fetch` on React Native — is a runtime concern the app injects. This port
 * is the seam: the typed client (`ApiClient`) speaks only `HttpRequest`/`HttpResponse`, so every request path,
 * header, retry, and error mapping is deterministic and unit-testable against an in-memory transport, and the
 * real transport is a thin adapter wired at app boot. No vendor SDK or URL library leaks into the domain.
 */
/**
 * The one error shape a transport is allowed to throw. Any other thrown value the client treats as a generic
 * network failure. `kind` lets the client distinguish a deadline (`TIMEOUT`) from connectivity (`NETWORK`)
 * without inspecting a vendor error class.
 */
export class HttpTransportError extends Error {
    kind;
    constructor(kind, message) {
        super(message ?? kind);
        this.name = 'HttpTransportError';
        this.kind = kind;
    }
}
//# sourceMappingURL=transport.js.map